export default [
  {
    path: '/vendingEasilyIntroduce', name: 'vendingEasilyIntroduce', component: () => import('@/pages/vendingEasily/vendingEasilyIntroduce'), meta: { title: '售货易' },
  },
  {
    path: '/vendingEasilyList', name: 'vendingEasilyList', component: () => import('@/pages/vendingEasily/vendingEasilyList'), meta: { title: '售货易' },
  },
  {
    path: '/vendingEasilyData', name: 'vendingEasilyData', component: () => import('@/pages/vendingEasily/vendingEasilyData'), meta: { title: '活动效果' },
  },
  {
    path: '/addVendingEasily', name: 'addVendingEasily', component: () => import('@/pages/vendingEasily/addVendingEasily'), meta: { title: '新建活动' },
  },
  {
    path: '/vendingEasilyGoods', name: 'vendingEasilyGoods', component: () => import('@/pages/vendingEasily/vendingEasilyGoods'), meta: { title: '商品' },
  },
  {
    path: '/vendingEasilyDetail', name: 'vendingEasilyDetail', component: () => import('@/pages/vendingEasily/vendingEasilyDetail'), meta: { title: '售货易' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/vendingEasily.js